import { backofficeRequest } from '../../../axios'

export const getCoownersByCoproId = async (coproId) => {
  try {
    const response = await backofficeRequest.get(
      `backoffice/coowners/${coproId}`
    )
    return response
  } catch (error) {
    return error.response
  }
}
export default getCoownersByCoproId
